import i18n from 'i18next';

import addAudienceChipsModal from '../helpers/addAudienceChipsModal';
import getInitiativeTypes from '../helpers/getInitiativeTypes';

export default () => [
  {
    title: i18n.t('initiative'),
    schema: {
      name: {
        type: 'Text',
        label: i18n.t('initiative-name'),
        help: i18n.t('initiative-name-help'),
        maxLength: 50,
        validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
      },
      initiative_type: {
        type: 'Select',
        label: i18n.t('initiative-type'),
        help: i18n.t('initiative-type-help'),
        options: getInitiativeTypes(),
        selectProps: { isFluid: true, isFullWidth: true },
        validators: [{ type: 'isRequired' }],
      },
      description: {
        type: 'TextEditor',
        label: i18n.t('initiative-description'),
        help: i18n.t('initiative-description-help'),
        textEditorOptions: { hasToolbar: true },
      },
    },
  },
  {
    title: i18n.t('audience'),
    schema: {
      audiences: {
        type: 'InitiativeChips',
        label: i18n.t('audience-selection'),
        help: i18n.t('audience-selection-help'),
        addButtonText: i18n.t('add-an-audience'),
        emptyText: i18n.t('audience-selection-empty'),
        onAddButtonClick: async (chips) => {
          const { payload, type } = await addAudienceChipsModal(chips);

          return type === 'save' ? payload.audiences : chips;
        },
      },
    },
  },
  {
    title: i18n.t('additional-tracking'),
    schema: {
      social_tracking: {
        type: 'Boolean',
        label: i18n.t('social'),
        help: i18n.t('social-tracking-help'),
        labelText: i18n.t('social-tracking-enable'),
      },
      ecommerce_tracking: {
        type: 'Boolean',
        label: i18n.t('ecommerce'),
        help: i18n.t('ecommerce-tracking-help'),
        labelText: i18n.t('ecommerce-tracking-enable'),
      },
      live_tracking: {
        type: 'Boolean',
        label: i18n.t('instructor-led'),
        help: i18n.t('instructor-led-tracking-help'),
        labelText: i18n.t('instructor-led-tracking-enable'),
      },
    },
  },
];
